import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { EntityArt } from '@helper/enums/entityArt.enum';
import { SpinnerService } from '@services/spinner.service';
import { AjaxService } from 'AjaxService';

interface IDokumentArchiveViewModel {
  ownerId: number;
  entityArt: EntityArt;

  id: number;
  alteId: string;
  title: string;
  oldPfad: string;
  date: string;
  fileName: string;
  contentType: string;
  forEntityType: string;
}

@Component({
    selector: 'cz-dokumente-archive',
    templateUrl: './dokumente-archive.component.html',
    styleUrls: ['./dokumente-archive.component.css'],
    standalone: false
})
export class DokumenteArchiveComponent implements OnInit {

  loading = false;
  von?: Date;
  bis?: Date;
  vorschauPopupVisible: boolean = false;
  fileName: string;

  @Input() entityArt: EntityArt;
  @Input() ownerId: number;

  dataSource: IDokumentArchiveViewModel[];

  constructor(private spinnerService: SpinnerService, private ajaxService: AjaxService) {
    this.cloneDownloadClick = this.cloneDownloadClick.bind(this);
    this.cloneVorschauClick = this.cloneVorschauClick.bind(this);
    this.hidePopup = this.hidePopup.bind(this);
  }

  ngOnInit(): void {
    this.loadDocuments();
  }

  changeValue(event) {
    this.loadDocuments();
  }

  loadDocuments() {
    this.startLoading();
    this.ajaxService.post<IDokumentArchiveViewModel[]>('api/DokumentArchive/Get', { entityArt: this.entityArt, ownerId: this.ownerId, von: this.von, bis: this.bis }).subscribe(response => {
      this.dataSource = response;
      this.stopLoading();
    });
  }

  cloneDownloadClick(e) {
    this.ajaxService.post<string>('api/DokumentArchive/CheckDocumentFileExist', { id: e.row.data.id }).subscribe(response => {
      if (response) {
        this.ajaxService.download('/api/DokumentArchive/Download?fileName=' + response, response);
      }
    });
  }

  cloneVorschauClick(e) {
    if (this.isToShow(e.row.data.fileName)) {
      this.fileName = e.row.data.fileName;
      this.vorschauPopupVisible = true;
    }
  }

  onHiddenPopup(event) {
    this.vorschauPopupVisible = false;
  }

  hidePopup() {
    this.vorschauPopupVisible = false;
  }

  isToShow(fileName: string): boolean {

    const ext = this.getFileExtension(fileName).toLowerCase();

    if (ext) {
      if (ext === '.pdf' ||
        ext === '.docx' ||
        ext === '.doc'
      ) {
        return true;
      }
    }

    return false;
  }


  getFileExtension(fileName: string) {
    if (fileName) {
      return (/[.]/.exec(fileName)) ? '.' + /[^.]+$/.exec(fileName)[0] : undefined;
    }
    return null;

  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;
    const searchPanel = toolbarItems.filter(item => item.name === 'searchPanel');

    if (searchPanel && searchPanel[0]) {
      searchPanel[0].location = 'before';
    }

    e.toolbarOptions.items.push({
      location: 'after',
      template: 'searchBarTemplateVon'
    });

    e.toolbarOptions.items.push({
      location: 'after',
      template: 'searchBarTemplateBis'
    });
  }

  private startLoading() {
    this.spinnerService.show();
    this.loading = true;
  }

  private stopLoading() {
    this.spinnerService.hide();
    this.loading = false;
  }
}
